
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Service from "../Service/http";
import { useParams, Link } from "react-router-dom";
import * as XLSX from 'xlsx'
import moment from "moment";
import { VscCloudDownload } from "react-icons/vsc"
import { FcDownload } from "react-icons/fc"
import { BiArrowBack, BiToggleLeft, BiToggleRight } from "react-icons/bi"
import { FadeLoader } from "react-spinners";
import * as xlsx from "xlsx";
import { Tooltip } from "@mui/material";

function Attendance() {
  
    const service = new Service();
    
    let [studentsCount, setStudentsCount] = useState(0);
    let [unmarkedStudents, setUnmarkedStudents] = useState([]);
    let [markedStudents, setMarkedStudents] = useState([]);
    let [sessionData, setSessionData] = useState(null);
    let [sessionStudents, setSessionStudents] = useState([])
    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let [upLoading, setUpLoading] = useState(false);
    let [buttonText, setButtonText] = useState("Upload Data");
    let [refresh, setRefresh] = useState(false);
    let { sessionId } = useParams();
    let [currentStudent, setCurrentStudent] = useState(null);
    let [attendanceId, setAttendanceId] = useState(null);
    let [hideAttendanceControlCard, setHideAttendanceControlCard] = useState(false)
    let [statusCounts, setStatusCounts] = useState({
      PRESENT: 0,
      ABSENT: 0,
      ABSENT_PREINFORMED: 0,
      ABSENT_WITH_PERMISSION: 0
    });

    let statusColors = {
      PRESENT:                "#A2FF33",
      ABSENT:                 "#FD471E",
      ABSENT_PREINFORMED:     "#FD8E1E",
      ABSENT_WITH_PERMISSION: "#FD8E1E",
    }

    const sortFn = (student1, student2) => (student1.student_id.roll_number > student2.student_id.roll_number) ? 1: -1;
    const reverseSortFn = (student1, student2) => (student1.student_id.roll_number < student2.student_id.roll_number) ? 1: -1;
    const getSessionAndStudentsData = () => {
      setLoading(true);
      service
        .get("api/attendance-session/session/" + sessionId)
        .then((json) => {
            setLoading(false);

            if(json.hasOwnProperty('sessionData')) {
              setSessionData(json.sessionData);
            } else {
              toast.error("Someting went wrong");
            }

            if(json.hasOwnProperty('sessionStudents')) {
              setStudentsCount(json?.sessionStudents?.length);
              setSessionStudents(json?.sessionStudents);

              let unmarkedStudentsList = json?.sessionStudents?.filter((student) => student.status === null).sort(reverseSortFn);
              setUnmarkedStudents(unmarkedStudentsList);
              setHideAttendanceControlCard(unmarkedStudentsList.length === 0)
              
              setMarkedStudents(json?.sessionStudents?.filter((student) => student.status !== null).sort(sortFn));              
              setStatusCounts(countStatuses(json?.sessionStudents));
            } else {
              toast.error("Someting went wrong");
            }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Someting went wrong");
        });
    }

    function BuildCSV(){
      const download_data = [...markedStudents, ...unmarkedStudents];
      if (download_data.length === 0) {
        return;
      }
    
      const workbook = XLSX.utils.book_new();
      const sheetName = 'Students';
      const worksheet = XLSX.utils.json_to_sheet(download_data.map(row => ({
        'Name': row?.student_id?.name || "",
        'Roll Number': row?.student_id?.roll_number || "",
        'Status': row?.status || "",
        'Remarks': row?.remarks || ""
      })));
    
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    
      const fileName = [
        sessionData?.batch_id?.batch_name,
        sessionData?.session_name,
        moment(new Date(sessionData?.session_start_time)).format('Do MMM YYYY h:mma')
      ].join(" - ") + '.xlsx';
    
      XLSX.writeFile(workbook, fileName);
    }
    
    function BuildSampleCSV(){
      const download_data = [...markedStudents, ...unmarkedStudents];
      if (download_data.length === 0) {
        return;
      }
    
      const workbook = XLSX.utils.book_new();
      const sheetName = 'Students';
      const worksheetData = download_data.map((row) => ({
        'Name': row?.student_id?.name || "",
        'Roll Number': row?.student_id?.roll_number || "",
        'Status': "",
        'Remarks': ""
      }));
      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    
      const fileName = [
        sessionData?.batch_id?.batch_name,
        sessionData?.session_name,
        moment(new Date(sessionData?.session_start_time)).format('Do MMM YYYY h:mma')
      ].join(" - ") + '.xlsx';
    
      XLSX.writeFile(workbook, fileName);
    }

    const markStatus = (status) => {
      updateAttendance(currentStudent?._id, status, null, false, false);
    };

    const countStatuses = (students) => {
      let counts = {
        PRESENT: 0,
        ABSENT: 0,
        ABSENT_PREINFORMED: 0,
        ABSENT_WITH_PERMISSION: 0
      };

      students.forEach((student) => {
        if(["PRESENT", "ABSENT", "ABSENT_PREINFORMED", "ABSENT_WITH_PERMISSION"].includes(student.status)) {
          counts[student.status] += 1;
        }
      });
      return counts;
    };

    const selectNextStudent = (direction = 1) => {

      let index = unmarkedStudents.findIndex((student) => student._id === currentStudent._id);

      if(index === unmarkedStudents.length-1 && direction === 1) {
        index = -1;
      } else if(index === 0 && direction === -1) {
        index = unmarkedStudents.length;
      }

      if (direction === 1) {
          setCurrentStudent(unmarkedStudents[index + 1]);
          setAttendanceId(unmarkedStudents[index + 1]?._id);
      } else {
          setCurrentStudent(unmarkedStudents[index - 1]);
          setAttendanceId(unmarkedStudents[index - 1]?._id);
      }
    };

    const handleSelectCurrentStudent = (student) => {
      setCurrentStudent(student);
      setAttendanceId(student._id);
      setHideAttendanceControlCard(false)
    };

    const toggleCenterPanel = () => {
      setHideAttendanceControlCard(!hideAttendanceControlCard)
    }
  
    const updateAttendance = (attendanceId, status, remarks, is_deleted, through_csv) => {
      service
        .post("api/attendance-session/" + sessionData._id + "/attendance/" + attendanceId, { status, remarks, is_deleted })
        .then((json) => {
          if(!through_csv){
            setLoading(false);
            // update current student status in currentStudent
            currentStudent.status = status;
            setCurrentStudent(currentStudent);
            setMarkedStudents([currentStudent, ...markedStudents.filter(student => student._id !== currentStudent._id)]);

            // remove current student from unmarked students
            setUnmarkedStudents(unmarkedStudents.filter((student) => student._id !== currentStudent._id));

            // select the next student
            selectNextStudent();
          }
        })
        .catch((error) => {
          toast.error("Error while updating attendance");
          console.error(error);
        });
    };

    // This function takes the CSV data in json format and updates the attendance of the students
    async function markAttendanceWithCsv(data){
      setUpLoading(true);
      if(!data)
        {
          toast.error("File Not Uploaded or Empty");
          setUpLoading(false);
          return;
        }
        setButtonText("Uploading Data ... ")
      let roll_number_attendance_id_map = {};
      await service
        .get(`api/attendance/${sessionId}`)
        .then((res) =>{
          res.forEach((row) => {
            let roll_number = row.student_id.roll_number;
            let attendanceId = row._id;
            roll_number_attendance_id_map[roll_number] = attendanceId;
          });
          data.forEach((row) => {
            let roll_number = row["Roll Number"]? row["Roll Number"].toString().trim() : "";
            let status = row["Status"] ? row["Status"].toString().trim() : "";
            if(status.toLowerCase() === "p" || status.toLowerCase() === "present") status = "PRESENT";
            else if(status.toLowerCase() === "a" || status.toLowerCase() === "absent") status = "ABSENT";

            let remarks = row["Remarks"] ? row["Remarks"].toString().trim() : "";
            let attendanceId = roll_number_attendance_id_map[roll_number];
            if(attendanceId && roll_number !== ''){
              updateAttendance(attendanceId,status,remarks,false,true);
            }
          });
          toast.success("Attendance Has been saved (Reload to view changes)");
        })
        .catch((error) => {
          toast.error("Error while updating attendance through CSV file");
          console.error(error);
          return;
        })
        setButtonText("Uploaded")

    }

    const handleCsvUpload = (e) => {
      setLoading(true);
        try{
            e.preventDefault();
            if (e && e.target && e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                let data = e.target.result;
                const workbook = xlsx.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);
                setData(json);
            };
            toast.success("File Uploaded Successfully");
            reader.readAsArrayBuffer(e.target.files[0]);
            }
        }
        catch(err){
            toast.error("Error while updating attendance");
            console.error(err);
        }
        setLoading(false);
    };

    const filterToMarkList = (e) => {
      setUnmarkedStudents(sessionStudents?.filter((student) => 
        student.status === null && (student?.student_id?.roll_number?.toLowerCase()?.includes(e.target.value.toLowerCase()) || 
        student?.student_id?.name?.toLowerCase()?.includes(e.target.value.toLowerCase())
      )));
    }

    const filterMarkedList = (e) => {
      setMarkedStudents(sessionStudents?.filter((student) => 
        student.status !== null && (student?.student_id?.roll_number?.toLowerCase()?.includes(e.target.value.toLowerCase()) || 
              student?.student_id?.name?.toLowerCase()?.includes(e.target.value.toLowerCase())
      )))
    }

    useEffect(() => {
        getSessionAndStudentsData();
    }, [refresh]);
        
    useEffect(() => {
        if(unmarkedStudents.length > 0) {
          setCurrentStudent(unmarkedStudents[0]);
          setAttendanceId(unmarkedStudents[0]._id);
        }
    }, [sessionData]);

    useEffect(() => {
      if(unmarkedStudents.length === 0) {
        setHideAttendanceControlCard(true)
        setCurrentStudent(null)
        setAttendanceId(null)
        return;
      }
    }, [unmarkedStudents]);

    useEffect(() => {
      setStatusCounts(countStatuses(markedStudents));
    }, [markedStudents]);
  
  return (
    <div>
      { loading ? <div className="text-center"><FadeLoader color={"grey"}/></div> : "" }
      <div id="attendanceContainer" className="container">
        <div id="attendanceTitleDiv" className="bg-white mb-3 border border-secondary rounded">
          <div id="attendanceNameAndIcons" className="d-flex justify-content-between">          
            <Link className="nav-link" title="All Attendance Sessions" to="/attendance-session">                  
              <BiArrowBack size={25} />
            </Link>
            <h3 id="attendanceSessionName" className="text-secondary text-capitalize mt-3" title="Attendance Session Name">{sessionData?.session_name}</h3>
            <Tooltip title="Download Batch Attendance" placement="left-start" arrow>
            <span className=" border-0 my-1 mx-1" style={{"cursor":"pointer"}}>
            <VscCloudDownload
              title="Download Attendance in CSV"
              size={30}
              onClick={BuildCSV}
              className="text-primary"
              />
              </span>
            </Tooltip>
          </div>
          <h5 className="text-secondary text-capitalize mb-3 text-center" title="Batch Name">{sessionData?.batch_id?.batch_name}</h5>
          <h6 className="text-secondary text-capitalize text-center">
              {moment(new Date(sessionData?.session_start_time)).format('ddd Do MMM YYYY')}
          </h6>
          <h6 className="text-secondary text-capitalize text-center">
              {moment(new Date(sessionData?.session_start_time)).format('h:mma')} - {moment(new Date(sessionData?.session_end_time)).format('h:mma')}
          </h6>
          <h6>{sessionData?.attendance_taken_by}</h6>
        </div>
        <div className="my- mt-3">
          <h2>Important Note For Uploading</h2>
          <p>Below are the important details to consider:</p>
          <ul>
            <li>To upload Attendance Download the batch-list and mark attendance in batch-list itself.</li>
            <li> <strong> Roll Number </strong> and <strong>Status </strong> are mandatory fields. </li>
            <li>In the Status you can mark attendance as any of the following {"{Present/P , Absent/A}"} without worrying about case of letters. </li>
            <li> <strong> It is mandatory to mark attendance for all the students in that list. </strong></li>
          </ul>
          <div className="d-flex mt-3">
            <h5 className="text-secondary text-center me-2">
              <strong> Upload Attendance (.csv .xlsx .xls) </strong>
            </h5>
            <button onClick={BuildSampleCSV} style={{"border":"0"}} className="text-primary me-3 mb-2"> 
              <FcDownload /> Download Batch List
            </button>
            
            
          </div>
          <input className="form-control" type="file" placeholder="Upload VQR Scores for Users" accept=".csv,.xlsx,.xls" disabled={loading} onChange={(e) => { handleCsvUpload(e); }}/>
          <div>
            <button disabled={upLoading} onClick={() => { markAttendanceWithCsv(data); }} className={ upLoading ? "btn btn-secondary m-2 mx-2 float-end" : "btn btn-success m-2 mx-2 float-end cursor-pointer" } > {buttonText} </button>
          </div>
        </div>
        <div className="row h100-scroll text-uppercase" style={{"marginTop":"5%"}}>
          <div className="col-sm-3 col">
            <div className="card studentsListCard">
              <div className="card-body">
                <div className="card-title d-flex justify-content-between flex-column">
                  <div className="h5 m-0">To mark</div>
                  <div className="mb-2"><small>{unmarkedStudents?.length} / {studentsCount}</small></div>
                  <div>
                    <input type="text" className="form-control" onChange={filterToMarkList} placeholder="Name or Roll Number"/>
                  </div>
                </div>
                <hr/>
                <table className="table table-striped">
                  <tbody>
                    {unmarkedStudents?.map((student, index) => (
                      <tr key={student?.student_id?._id}
                        style = {{backgroundColor: `${student?._id === currentStudent?._id ? "lightblue" : ""}`}}
                        onClick={() => { handleSelectCurrentStudent(student) }}
                      >
                        <td>{student?.student_id?.name}<br /><small>{student?.student_id?.roll_number}</small></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col">
            <div className="card studentsListCard" style={{ display: (hideAttendanceControlCard === true ? 'none' : 'flex') }}>
              <span className="centerPanelToggle text-secondary p-2"> <span className="my-1 mx-1"> Left Over Attendance </span> <BiToggleLeft onClick={toggleCenterPanel} size={30}> </BiToggleLeft></span>
              <div className="card-body">
                  <h5 className="card-title text-center mt-4">{currentStudent?.student_id?.name}</h5>
                  <h3 className="card-title text-center">{currentStudent?.student_id?.roll_number || "-"}</h3>
                  <br /><br />
                  <div className="row text-center">
                    <div className="col-md-6 mb-3">
                      <button className="btn btn-success btn-block btn-80" type="button" onClick={() => {markStatus('PRESENT')}}>Present</button>
                    </div>
                    <div className="col-md-6 mb-3">
                      <button className="btn btn-danger btn-block btn-80" type="button" onClick={() => {markStatus('ABSENT')}}>Absent</button>
                    </div>
                  </div>
                  <div className="row text-center">
                    <div className="col-md-6 mb-3">
                      <button className="btn btn-warning btn-block btn-80" type="button" onClick={() => {markStatus('ABSENT_PREINFORMED')}}>Absent pre-informed</button>
                    </div>
                    <div className="col-md-6 mb-3">
                      <button className="btn btn-warning btn-block btn-80" type="button" onClick={() => {markStatus('ABSENT_WITH_PERMISSION')}}>Absent with permission</button>
                    </div>
                  </div>
                  <div style={{ display: (unmarkedStudents.length === 0 ? "none" : "block") }}>
                    <div className="mt-5 d-flex justify-content-between">
                      <button className="btn float-start" onClick={() => {selectNextStudent(-1)}}>&nbsp; &lt; &nbsp; Prev</button>
                      <button className="btn float-end" onClick={() => {selectNextStudent()}}>Next &nbsp; &gt; &nbsp;</button>
                    </div>
                  </div>
              </div>
            </div>
            <div className="card studentsListCard" style={{ display: (hideAttendanceControlCard === false ? 'none' : 'flex') }}>
              <span
                style={{ display: (attendanceId === null ? 'none' : 'flex')}}
                className="centerPanelToggle p-2 text-secondary"> 
                <span className="my-1 mx-1">Attendance Summary</span>
                <BiToggleRight onClick={toggleCenterPanel} size={30}></BiToggleRight>
              </span>
                  <h3 className="text-center pt-5"> Attendance Summary</h3>
              <div className="card-body d-flex align-items-center">
                <table className="table table-bordered text-center align-middle">
                  <tbody>
                    <tr className="table-secondary">
                      <td colSpan="5"><strong>STATS</strong></td>
                    </tr>
                    <tr>
                      <td><span style={{ color: statusColors["PRESENT"] }}>●</span></td>
                      <td>Present</td>
                      <td>{statusCounts['PRESENT']}</td>
                      <td>{Math.round(statusCounts['PRESENT']/studentsCount*100)} %</td>
                      <td>{Math.round(statusCounts['PRESENT']/studentsCount*100)} %</td>
                    </tr>
                    <tr>
                      <td><span style={{ color: statusColors["ABSENT"] }}>●</span></td>
                      <td>Absent</td>
                      <td>{statusCounts['ABSENT']}</td>
                      <td>{Math.round(statusCounts['ABSENT']/studentsCount*100)} %</td>
                      <td rowSpan="3">{Math.round((statusCounts['ABSENT']+statusCounts['ABSENT_PREINFORMED']+statusCounts['ABSENT_WITH_PERMISSION'])/studentsCount*100)} %</td>
                    </tr>
                    <tr>
                      <td><span style={{ color: statusColors["ABSENT_PREINFORMED"] }}>●</span></td>
                      <td>Absent pre-informed</td>
                      <td>{statusCounts['ABSENT_PREINFORMED']}</td>
                      <td>{Math.round(statusCounts['ABSENT_PREINFORMED']/studentsCount*100)} %</td>
                    </tr>
                    <tr>
                      <td><span style={{ color: statusColors["ABSENT_WITH_PERMISSION"] }}>●</span></td>
                      <td>Absent with permission</td>
                      <td>{statusCounts['ABSENT_WITH_PERMISSION']}</td>
                      <td>{Math.round(statusCounts['ABSENT_WITH_PERMISSION']/studentsCount*100)} %</td>
                    </tr>
                    <tr className="table-secondary">
                      <td></td>
                      <td><strong>Total</strong></td>
                      <td>{statusCounts['PRESENT'] + statusCounts['ABSENT'] + statusCounts['ABSENT_PREINFORMED'] + statusCounts['ABSENT_WITH_PERMISSION']} / {studentsCount} </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-sm- col">
            <div className="card studentsListCard">
              <div className="card-body">
                <div className="card-title d-flex justify-content-between flex-column">
                  <div className="h5 m-0">Marked</div>
                  <div className="mb-2"><small>{markedStudents?.length} / {studentsCount}</small></div>
                  <div>
                    <input type="text" className="form-control" onChange={filterMarkedList} placeholder="Name or Roll Number"/>
                  </div>
                </div>
                <hr/>
                <table className="table table-striped">
                  <tbody>
                    {markedStudents?.map((student, index) => (
                      <tr
                        key={student?.student_id?._id}
                        style = {{backgroundColor: `${student?._id === currentStudent?._id ? "lightblue" : ""}`}}
                        onClick={() => { handleSelectCurrentStudent(student) }}
                      >
                        <td> <span style={{ color: statusColors[student?.status] }}>●</span> {student.student_id.name}<br /><small>{student.student_id.roll_number}</small></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="spacer"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Attendance;
